module.exports = __webpack_public_path__ + "media/images/ico-export-be6949ce.svg";